import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button, Typography, Space, Row, Breadcrumb } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const PageHeader = ({ title, isSticky = false, actionGroup, onBack }) => {
  return (
    <Row
      justify="space-between"
      align="middle"
      style={
        isSticky
          ? {
              zIndex: 2,
              padding: "0.5rem 0",
              background: "white",
              position: "sticky",
              top: 0,
            }
          : {
              zIndex: 2,
              padding: "0.5rem 0",
              background: "white",
            }
      }
    >
      <Button
        type="text"
        size="large"
        icon={<ArrowLeftOutlined />}
        onClick={onBack}
      >
        <Title level={3} style={{ margin: 0 }}>
          {title}
        </Title>
      </Button>
      {actionGroup}
    </Row>
  );
};

export default PageHeader;
